import { render, staticRenderFns } from "./ApprovalPageHeader.vue?vue&type=template&id=988eecce&scoped=true&"
import script from "./ApprovalPageHeader.vue?vue&type=script&lang=ts&"
export * from "./ApprovalPageHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988eecce",
  null
  
)

export default component.exports